<script>
  import router from "page";
  import routes from "./routes.js";
  import Footer from "./components/Footer.svelte";


  let page;
  let params;
  export let user = false;

  // Iterate through the routes
  routes.forEach(route => {
    router(
      route.path,

      (ctx, next) => {
        params = ctx.params;
        next();
      },

      () => {
        if (route.auth && !user) {
          router.redirect("/login");
        } else {
          page = route.component;
        }
      }
    );
  });

  // Start the router
  router.start();


  // open/close nav

  let isOpen = false;
  let bodyWidth= document.body.clientWidth;
  let handleClick =() =>{
    console.log('can i pleases');
    isOpen = !isOpen;
    if(isOpen ===true){
      document.querySelector('.nav-links').style.display = 'flex';
    document.querySelector('.nav-links').style.flexDirection = 'column';
    document.querySelector('.nav-links').style.flexWrap = 'nowrap';
    document.querySelector('.nav-links').style.minWidth = '67vw';
    document.querySelector('.nav-links').style.transform = 'translate3d(-20vw,20px,0)';
    document.querySelector('.nav-links').style.background = 'rgba(255,75,0,0.8)';
    // document.querySelector('.nav-links').style.color = '#eee';
    // document.querySelector('.nav-links').style.height = '50vh';
  }
  if(isOpen ===false){
    document.querySelector('.nav-links').style.display = 'none';
  }
  }
  let navLinkClicked = () =>{
    
    if(bodyWidth < 800){document.querySelector('.nav-links').style.display = 'none';}

// document.querySelector('.nav-links').style.display = 'none';
window.scroll({
  top: 0, 
  left: 0, 
  behavior: 'smooth'
});
console.log("navlink did")
  }
</script>


<nav class="header" style='background: #000'>
 <!-- <a href="/"><div class="logo"></div></a> -->
  <div class="nav-links">
     <!-- <a href="/">Why TNR?</a> -->
     <a on:click={()=>{navLinkClicked()}} href="/">Home</a>
     <a on:click={()=>{navLinkClicked()}} href="https://soundcloud.com/tharealjayv?fbclid=IwAR1fAJo8gIWFXW3mKEv2cmvMNBoNPPaV9hq0R4Nj84FUUA8lKEtjGoW2jyg">Soundcloud</a>
     <a on:click={()=>{navLinkClicked()}} href="mailto:jaymzvaeth@yahoo.com">Send Beats</a>
     <!-- <a href="#">History</a> -->
     <a on:click={()=>{navLinkClicked()}} href="/listen">Listen</a>
     <a on:click={()=>{navLinkClicked()}} href="/about-us">About</a>
    
  </div>
  
  <div on:click={()=>{handleClick()}} class="mobile-menu"></div>
  
</nav>

<main>
 <svelte:component this={page} params={params} />
</main>
<!-- <Footer/> -->
<style>
  
  main,
  header {
    padding: 20px;

  }

  .header {
    font-family: 'Roboto', sans-serif;
  height: 5.625rem;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 1.875rem;
}
.header .logo {
  height: 3.75rem;
  width: 7.5rem;
  background: url('https://dl3.pushbulletusercontent.com/uq8NyoTAjhnvqYr6NFrsJPBbGD07OoVz/fhffLOGOtho.png');
  background-size: contain;
  background-repeat: no-repeat;

  /*margin-left: rem(30);*/
  margin-top: 0.9375rem;
  float: left;
}
.header .nav-links {
  float: right;
  /*margin-right: rem(30);*/
  display: none;
}
.nav-links a:hover {
color: #f90;
}
@media screen and (min-width: 1024px) {
  .header .nav-links {
    display: block;
  }
}

.header .mobile-menu {
  
  display: block;
  height: 0.125rem;
  width: 1.875rem;
  background: #eee;
  float: right;
  /*margin-right: rem(30);*/
  position: absolute;
  top: 2.0625rem;
  right:1em;
}
.header .mobile-menu:before, .header .mobile-menu:after {
  content: '';
  display: block;
  height: 0.125rem;
  width: 1.875rem;
  background: #eee;
  padding: 1px 2px 1px 2px;
}
.header .mobile-menu:before {
  margin: 0.5rem 0 0.375rem;
}
.header .mobile-menu:after {
  margin-top: 0.125rem;
}
@media screen and (min-width: 1024px) {
  .header .mobile-menu {
    display: none;
  }
}

.header .nav-links a {
  display: inline-block;
  text-decoration: none;
  color: #eee;
  margin-left: 1.875rem;
  line-height: 5.625rem;
  cursor: pointer;
}
.header .nav-links a:hover {

  color: #f90 !important;
  margin-left: 1.875rem;
  line-height: 5.625rem;
  cursor: pointer !important;
}
</style>